import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
// eslint-disable-next-line import/no-cycle
import { DAY_MARGIN, DAY_WIDTH, IconWrapper } from "./styled";

const TextSrOnly = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

const StyledNav = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;

  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.9);
  display: flex;
  font-weight: normal;
  height: calc(${(DAY_WIDTH * 9) / 7} - (2 * ${DAY_MARGIN}));
  justify-content: center;
  margin: ${DAY_MARGIN};
  outline: 0;
  padding: 0;
  width: calc(${(DAY_WIDTH * 9) / 7} - (2 * ${DAY_MARGIN}));

  &:focus,
  &:hover,
  &:active {
    ${IconWrapper} {
      color: var(--dui-color-red-500);
      fill: var(--dui-color-red-500);
    }

    cursor: pointer;
  }

  &:disabled {
    ${IconWrapper} {
      color: var(--dui-color-gray-300);
      fill: var(--dui-color-gray-300);
    }
    cursor: not-allowed;
  }
`;

export const NavIconButton = ({
  iconComponent,
  onClick,
  ariaLabel,
  id,
  rotate,
  disabled,
}) => (
  <StyledNav
    id={id}
    onClick={onClick}
    type="button"
    aria-labelledby={`${id}-label`}
    data-testid={id}
    disabled={disabled}
  >
    <IconWrapper rotate={rotate}>{iconComponent}</IconWrapper>
    {ariaLabel && <TextSrOnly id={`${id}-label`}>{ariaLabel}</TextSrOnly>}
  </StyledNav>
);

NavIconButton.propTypes = {
  id: PropTypes.string,
  /** Which direction the chevron should show */
  rotate: PropTypes.string,
  /** Callback or click handler for this nav item */
  onClick: PropTypes.func,
  /** Should disable this icon button? */
  disabled: PropTypes.bool,
  /** Aria label for this icon button */
  ariaLabel: PropTypes.string,
  /** React icon Component */
  iconComponent: PropTypes.element,
};
